export const trackClickedAttr = 'data-trk';

export type TrackClickedData = {
  name: string;
  properties?: Record<string, string>;
};

/**
 * There is no snippet for trackClicked because it is not used directly,
 * but rather via RichDetails and ClickActions
 */
export function trackClickedAttributes(data: TrackClickedData | undefined) {
  if (!data) return {};

  const attributes: Record<string, string> = {
    [trackClickedAttr]: data.name,
  };

  if (data.properties) {
    for (const [key, value] of Object.entries(data.properties)) {
      attributes[`${trackClickedAttr}-${key}`] = value;
    }
  }

  return attributes;
}
